<template>
  <div class="mall-text-field">
    <MallFieldLabel v-if="label" :label="label" :required="required" />
    <div class="mall-text-field__input-area">
      <input
        ref="input"
        class="mall-text-field__input"
        :class="{ 'mall-text-field__input--error': invalid || !!error, 'mall-text-field__input--readonly': readonly }"
        :type="type"
        :value="value"
        :placeholder="placeholder"
        :inputmode="inputmode"
        :maxlength="maxlength"
        :readonly="readonly"
        @input="onInput"
        @keydown="$emit('keydown', $event)"
        @blur="$emit('blur', $event)"
      />
      <span v-if="error" class="mall-text-field__error">{{ error }}</span>
      <span v-else-if="helper" class="mall-text-field__helper">{{ helper }}</span>
    </div>
  </div>
</template>

<script>
import MallFieldLabel from '@/components/new/atoms/MallFieldLabel.vue'

export default {
  name: 'MallTextField',
  components: {
    MallFieldLabel,
  },
  props: {
    value: {
      type: String,
      default: '',
    },
    // 없으면 라벨 미노출
    label: {
      type: String,
      default: '',
    },
    required: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: '',
    },
    inputmode: {
      type: String,
      default: 'text',
    },
    // 'text' | 'password'
    type: {
      type: String,
      default: 'text',
    },
    // 없으면 글자 수 제한 없음
    maxlength: {
      type: Number,
      default: null,
    },
    // 직접 입력 없이 눌러서 값을 고르는 칸 (주소 검색 등 - 클릭은 @click.native 로)
    readonly: {
      type: Boolean,
      default: false,
    },
    // 숫자만 입력 (다른 글자는 입력 즉시 지움)
    numeric: {
      type: Boolean,
      default: false,
    },
    helper: {
      type: String,
      default: '',
    },
    // 입력 오류 문구 (있으면 빨간 테두리 + helper 대신 노출)
    error: {
      type: String,
      default: '',
    },
    // 문구 없이 빨간 테두리만 (여러 칸이 문구 하나를 같이 쓸 때)
    invalid: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onInput(event) {
      var value = event.target.value
      if (this.numeric) {
        var digits = value.replace(/[^0-9]/g, '')
        if (digits !== value) {
          event.target.value = digits
        }
        value = digits
      }
      this.$emit('input', value)
    },
    focus() {
      this.$refs.input.focus()
    },
  },
}
</script>

<style scoped>
.mall-text-field {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.mall-text-field__input-area {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.mall-text-field__input {
  width: 100%;
  height: 48px;
  margin: 0;
  padding: 0 16px;
  border: 1px solid #D1D6DB;
  border-radius: 8px;
  background: #FFF;
  box-sizing: border-box;
  outline: none;
  color: var(--color-text-main);
  font-family: Pretendard;
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-medium);
  line-height: var(--line-height-normal);
  -webkit-appearance: none;
}

.mall-text-field__input::placeholder {
  color: #8B95A1;
}

.mall-text-field__input--readonly {
  cursor: pointer;
}

/* Focused: 2px #0096FF (레이아웃이 밀리지 않도록 inset shadow로 1px 보강) */
.mall-text-field__input:focus {
  border-color: #0096FF;
  box-shadow: inset 0 0 0 1px #0096FF;
}

.mall-text-field__input--error,
.mall-text-field__input--error:focus {
  border-color: #F04452;
}

.mall-text-field__input--error:focus {
  box-shadow: inset 0 0 0 1px #F04452;
}

/* 13px / 130% → Figma 렌더링 기준 17px */
.mall-text-field__helper,
.mall-text-field__error {
  padding: 0 4px;
  color: #8B95A1;
  font-family: Pretendard;
  font-size: var(--font-size-xs);
  font-weight: var(--font-weight-medium);
  line-height: 17px;
}

.mall-text-field__error {
  color: #F04452;
}
</style>



// WEBPACK FOOTER //
// src/components/new/molecules/MallTextField.vue